import { render, staticRenderFns } from "./UrineTest.vue?vue&type=template&id=193bebf2&scoped=true"
import script from "./UrineTest.vue?vue&type=script&lang=js"
export * from "./UrineTest.vue?vue&type=script&lang=js"
import style0 from "./UrineTest.vue?vue&type=style&index=0&id=193bebf2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193bebf2",
  null
  
)

export default component.exports